// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: 'AIzaSyCaTMr6ZJaLqEmSipVzxCceqcAmiho673U',
    authDomain: 'walter-app-931be.firebaseapp.com',
    databaseURL: 'https://walter-app-931be.firebaseio.com',
    projectId: 'walter-app-931be',
    storageBucket: 'walter-app-931be.appspot.com',
    messagingSenderId: '1020511870786',
    appId: '1:1020511870786:web:88a4222ec525e1c82e72db',
    measurementId: 'G-X46BC4KC7L',
};

export default firebaseConfig;
